// extracted by mini-css-extract-plugin
export var description = "MeetAiTwin-module--description--bI5aX";
export var featureContent = "MeetAiTwin-module--featureContent--BIWgx";
export var featureDescription = "MeetAiTwin-module--featureDescription--BgNkI";
export var featureIcon = "MeetAiTwin-module--featureIcon--oVRwi";
export var featureTitle = "MeetAiTwin-module--featureTitle--lpTtj";
export var headerSection = "MeetAiTwin-module--headerSection--tRPJ1";
export var leftContent = "MeetAiTwin-module--leftContent--5O5yS";
export var mainTitle = "MeetAiTwin-module--mainTitle--1Gy23";
export var meetAiTwinWrapper = "MeetAiTwin-module--meetAiTwinWrapper--4z9Qf";
export var mobileImage = "MeetAiTwin-module--mobileImage--tLS7c";
export var mobileImageWrapper = "MeetAiTwin-module--mobileImageWrapper--XK5pN";
export var rightContent = "MeetAiTwin-module--rightContent--PD0UN";